interface ScheduleConfig {
  type: "monthly" | "session" | null;
  price?: {
    type: "monthly" | "per_class" | "full_session" | null;
  } | null;
}

export function usesFullSessionPricing(
  schedule?: ScheduleConfig | null
): boolean {
  return schedule?.type === "session" && schedule?.price?.type === "full_session";
}
